import axios from "axios";
import {API_URL} from "../config";
import {
    showQualityControlStatisticsExportLoader,
    showQualityControlStatisticsLoader,
    updateQualityControlStatisticsSortFields
} from "../actions/actionsQualityControlStatistics";
import {
    GET_QUALITY_CONTROL_STATISTIC,
    GET_QUALITY_CONTROL_STATISTICS,
    GET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY,
    GET_QUALITY_CONTROL_STATISTICS_FILES_PAGINATION,
    GET_QUALITY_CONTROL_STATISTICS_PAGINATION,
    GET_QUALITY_CONTROL_STATISTICS_USER_SORT_FIELDS,
    SET_QUALITY_CONTROL_RATED_QUESTIONNAIRES,
    SET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY_LOADER,
    SHOW_QUALITY_CONTROL_STATISTICS_DETAIL_LOADING
} from "../types/typesQualityControlStatistics";
import {showAccessDeniedNotifications} from "../actions/actionsNotifications";
import {GET_NOTIFICATION_ERROR} from "../types/types";
import {setUserError} from "../actions/actionsUsersList";
import {SET_USER_STATUS_ERROR, SET_USER_STATUS_SUCCESS} from "../types/typesUsersList";
import {hideError, hideErrorMessage} from "../actions/actions";
import {qualityControlSortFieldsFetch} from "./sortFieldsFetchState";
import {normalizeSimpleUsersControls} from "../../components/Statistics/ManualEvaluationDialog/manualEvaluationQuestionnaires";
import type {TranscriptionByCallIdResponse} from "../../components/Statistics/ManualEvaluationDialog/manualEvaluationTranscription";
import type {ManualControlBlockPayload} from "../../components/Statistics/ManualEvaluationDialog/manualEvaluationControl";

const normalizeListItems = (items: any) => {
    if (!Array.isArray(items)) {
        return [];
    }

    return items.map((row) => {
        if (row?.item) {
            return row;
        }

        return {
            item: row,
            children: Array.isArray(row?.children) ? row.children : [],
        };
    });
};

export function getQualityControlStatisticsWithPaginationFilterAndSorting(data: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(showQualityControlStatisticsLoader(true))
        axios.post(`${API_URL}QualityControlStatistic/GetStatisticQualityControlWithPagination`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch({type: GET_QUALITY_CONTROL_STATISTICS, payload: normalizeListItems(response.data.data.items)})
                dispatch({type: GET_QUALITY_CONTROL_STATISTICS_PAGINATION, payload: response.data.data})
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true))
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch(showQualityControlStatisticsLoader(false))
            })
    }
}

export function getQualityControlStatisticsUserSortFields(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        if (!jwtToken) {
            return;
        }
        if (qualityControlSortFieldsFetch.requestInFlight) {
            return qualityControlSortFieldsFetch.requestInFlight;
        }
        if (qualityControlSortFieldsFetch.lastAttemptToken === jwtToken) {
            return;
        }

        qualityControlSortFieldsFetch.lastAttemptToken = jwtToken;
        qualityControlSortFieldsFetch.requestInFlight = axios.get(`${API_URL}QualityControlStatistic/GetUserSortFields`, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                const sortFieldsData = response.data.data;
                dispatch({type: GET_QUALITY_CONTROL_STATISTICS_USER_SORT_FIELDS, payload: sortFieldsData});
                localStorage.setItem('callcenter:user_quality_control_sort_fields', JSON.stringify(sortFieldsData?.fields));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SET_USER_STATUS_ERROR, payload: {message: 'Помилка завантаження даних'}})
                }
            })
            .finally(() => {
                qualityControlSortFieldsFetch.requestInFlight = null;
                dispatch(showAccessDeniedNotifications(false));
            });

        return qualityControlSortFieldsFetch.requestInFlight;
    }
}

export function getQualityControlStatisticToUserDetail(id: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SHOW_QUALITY_CONTROL_STATISTICS_DETAIL_LOADING, payload: true})
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        dispatch({type: SET_QUALITY_CONTROL_RATED_QUESTIONNAIRES, payload: []});

        Promise.all([
            axios.get(`${API_URL}Statistic/GetStatisticCallDetailById?callId=${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${jwtToken}`
                }
            }),
            fetchFormsByCallDetailId(id, true, jwtToken).catch(() => null),
        ])
            .then(([detailResponse, ratedFormsResponse]) => {
                dispatch({type: GET_QUALITY_CONTROL_STATISTIC, payload: detailResponse.data.data});

                const ratedQuestionnaires = ratedFormsResponse?.data?.statusCode === 200
                    ? normalizeSimpleUsersControls(ratedFormsResponse.data.data, {isRated: true})
                    : [];
                dispatch({type: SET_QUALITY_CONTROL_RATED_QUESTIONNAIRES, payload: ratedQuestionnaires});
            })
            .catch((e) => {
                dispatch({type: SHOW_QUALITY_CONTROL_STATISTICS_DETAIL_LOADING, payload: false})
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    if (e.data) {
                        dispatch({type: SET_USER_STATUS_ERROR, payload: {message: e.data.message}})
                    } else {
                        dispatch({type: SET_USER_STATUS_ERROR, payload: {message: 'Щось пішло не так.'}})
                    }
                }
            })
            .finally(() => {
                    dispatch(showAccessDeniedNotifications(false));
                    dispatch({type: SHOW_QUALITY_CONTROL_STATISTICS_DETAIL_LOADING, payload: false});
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
                    dispatch({type: SET_USER_STATUS_ERROR, payload: false})
                }
            )
    }
}

export function updateUserQualityControlStatisticFields(sortFields: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        axios.post(`${API_URL}QualityControlStatistic/UpdateUserSortFields`, sortFields, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": `Bearer ${jwtToken}`
            }
        })
            .then((response) => {
                dispatch(updateQualityControlStatisticsSortFields(response.data.data?.fields));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch({type: SET_USER_STATUS_ERROR, payload: {message: 'Помилка оновлення стовпців'}})
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_ERROR, payload: null});
            })
    }
}

export function fetchTranscriptionByCallId(callId: number, sessionId: string, jwtToken: string) {
    const params = new URLSearchParams({
        callId: String(callId),
        sessionId,
    });

    return axios.get<TranscriptionByCallIdResponse>(`${API_URL}QualityControlStatistic/TranscriptionByCallId?${params.toString()}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

export function fetchFormsByCallDetailId(
    callDetailId: number,
    isRated: boolean,
    jwtToken: string,
) {
    const params = new URLSearchParams({
        callDetailId: String(callDetailId),
        isRated: String(isRated),
    });

    return axios.get(`${API_URL}QualityControlStatistic/GetFormsByCallDetailId?${params.toString()}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

export function fetchControlResult(
    callDetailId: number,
    qualityControlId: number,
    jwtToken: string,
) {
    const params = new URLSearchParams({
        callDetailId: String(callDetailId),
        qualityControlId: String(qualityControlId),
    });

    return axios.get(`${API_URL}QualityControlStatistic/GetControlResult?${params.toString()}`, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

export function saveManualControl(
    callDetailId: number,
    qualityControlId: number,
    payload: ManualControlBlockPayload,
    jwtToken: string,
) {
    const params = new URLSearchParams({
        callDetailId: String(callDetailId),
        qualityControlId: String(qualityControlId),
    });

    return axios.post(`${API_URL}QualityControlStatistic/ManualControl?${params.toString()}`, payload, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

export function completeControl(
    callDetailId: number,
    qualityControlId: number,
    jwtToken: string,
) {
    const params = new URLSearchParams({
        callDetailId: String(callDetailId),
        qualityControlId: String(qualityControlId),
    });

    return axios.post(`${API_URL}QualityControlStatistic/CompleteControl?${params.toString()}`, null, {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${jwtToken}`,
        },
    });
}

export function generateQualityControlStatisticExcel(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showQualityControlStatisticsExportLoader(true));
        return axios.post(`${API_URL}Statistic/GenerateStatistic?type=6`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                return true;
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch(setUserError(true));
                }
                return false;
            })
            .finally(() => {
                dispatch(showQualityControlStatisticsExportLoader(false));
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
                dispatch(setUserError(false));
            });
    };
}

export function getQualityControlStatisticsFilesHistory(dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch({type: SET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY_LOADER, payload: true});
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
        axios.post(`${API_URL}Statistic/GetFilesHistory?type=6`, dataSort, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: GET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY, payload: response.data.data.items});
                dispatch({type: GET_QUALITY_CONTROL_STATISTICS_FILES_PAGINATION, payload: response.data.data});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    dispatch({type: GET_NOTIFICATION_ERROR, payload: true});
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                dispatch({type: SET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY_LOADER, payload: false});
                dispatch({type: GET_NOTIFICATION_ERROR, payload: false});
            });
    };
}

export function deleteQualityControlStatisticsFileById(id: number | any, dataSort: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.delete(`${API_URL}Statistic/DeleteFileById?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch(getQualityControlStatisticsFilesHistory(dataSort, jwtToken));
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function deleteAllQualityControlStatisticsFiles(jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        axios.delete(`${API_URL}Statistic/DeleteAllFiles`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: response.data.message}});
                dispatch({type: GET_QUALITY_CONTROL_STATISTICS_FILES_HISTORY, payload: []});
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}

export function getQualityControlStatisticExcelByLink(id: any, jwtToken: any) {
    return (dispatch: (arg0: any) => void) => {
        dispatch(hideError());
        dispatch(hideErrorMessage());
        dispatch(showQualityControlStatisticsExportLoader(true));
        axios.get(`${API_URL}Statistic/GetTempUrlFile?id=${id}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwtToken}`,
            },
            responseType: 'json',
        })
            .then((response) => {
                const fileUrl = response.data.data;
                const fileName = response.data.title || 'export.xlsx';

                if (fileUrl) {
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                } else {
                    dispatch(setUserError(true));
                }
            })
            .catch((e) => {
                if (e?.response?.status === 401) {
                    dispatch(showAccessDeniedNotifications(true));
                } else {
                    return dispatch(setUserError(true));
                }
            })
            .finally(() => {
                dispatch(showQualityControlStatisticsExportLoader(false));
                dispatch(showAccessDeniedNotifications(false));
                return dispatch(setUserError(false));
            });
    };
}
